import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

export default function TradeModeSelector({ tradeMode, onTradeModeChange, range }) {
  return (
    // 移除 absolute 定位，改用 flex 排版，並加上 mt: -3 縮短與圖表的距離
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: -3, mb: 1, pl: 2 }}>
      <RadioGroup
        row
        value={range === 365*100 + 31 ? "combined" : tradeMode}
        onChange={(e) => onTradeModeChange(e.target.value)}
      >
        {range === 365*100 + 31 ? (
          <FormControlLabel value="combined" control={<Radio />} label="綜合" />
        ) : (
          <>
            <FormControlLabel value="import" control={<Radio />} label="進口" />
            <FormControlLabel value="export" control={<Radio />} label="出口" />
            <FormControlLabel value="combined" control={<Radio />} label="綜合" />
          </>
        )}
      </RadioGroup>
    </Box>
  );
}